module.exports = __webpack_public_path__ + "media/images/athletes/23-3697b441d685eced90d384b5c7c81e8a.png";